import React, { createContext, useEffect, useState } from 'react'
import CustomTable from '../../Table/CustomTable'
import { formatMoney } from '../../../features/utils/formatMoney';
import acceptPayoutRequest from '../../../controllers/settings/wallet/acceptPayoutRequest';
import { enqueueSnackbar } from 'notistack';
import rejectPayoutRequest from '../../../controllers/settings/wallet/rejectPayoutRequest';
import { alertType } from '../../../data/constants';
import getAgentBankAccount from '../../../controllers/Bank/getAgentBanks';
import confirmManualPayoutRequest from '../../../controllers/settings/wallet/confirmManualPayoutRequest';
import isPayoutOTPNeeded from '../../../controllers/settings/wallet/isPayoutOTPNeeded';
import finalizePayout from '../../../controllers/settings/wallet/finalizePayout';
import resendPayoutOTP from '../../../controllers/settings/wallet/resendPayoutOTP';
import getPayoutBalanceLedger from '../../../controllers/settings/wallet/checkBalance';

const ActionsContext = createContext();

export default function PayoutLederTable() {
    const [data,setData] = useState([])
    const [openReject,setOpenReject] = useState(false);
    const [openAccept,setOpenAccept] = useState(false);
    const [openConfirm,setOpenConfirm] = useState(false);
    const [openOTPModal,setOpenOTPModal] = useState(false);
    const [view,setView] = useState();
    const [loadings,setLoadings] = useState({load: false,accept: false,reject: false})
    const [range,setRange] = useState({from: '',to: ''})

    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 20,
        rowCount: 0,
    });

    const [searchValue,setSearchValue] = useState('');

    useEffect(() => {
        load();

        //eslint-disable-next-line
    },[paginationModel?.page,searchValue])

    useEffect(() => {
        if(view && !view?.fetched)
            loadBankDetails();
        //eslint-disable-next-line
    },[view])

    async function load() {
        const query = {
            limit: paginationModel?.pageSize,
            offset: paginationModel?.page*paginationModel?.pageSize,
        }
        if(range?.from && range?.to) {
            query.range = `${range?.from},${range?.to}`
        }
        if(searchValue) {
            query.searchBy = 'bankAccount,ammount,status,account.firstName,account.lastName,account.email,account.phone';
            query.keyword = searchValue;
          }


        setLoadings({...loadings,load: true})
        const res = await getPayoutBalanceLedger(new URLSearchParams(query)?.toString());
        setLoadings({...loadings,load: false})
        if(res?.return) {
            setData(res?.data?.data)
            setPaginationModel({...paginationModel,rowCount: res?.data?.meta?.total})
        }
    }

    async function loadBankDetails() {
        const res = await getAgentBankAccount(view?.account?._id);
        if(res?.return) {
            setView({...view,bankDetails: res?.data?.data?.find(obj => obj?._id === view?.bankAccount),fetched: true})
        } else {
            enqueueSnackbar(res.msg,{variant: 'error'})
            setView({fetched: true});
        }
    }
    console.log(view)
    
    const columns = [
        { field: "user", headerName: "User", flex: 1,
            renderCell: (params) => (
                <div>
                    {params?.row?.account?.firstName || ''} {params?.row?.account?.middleName || ''} {params?.row?.account?.lastName || ''}
                </div>
            )
        },
        {field: 'bankAccount', headerName: "Bank Account", flex: 1,
            renderCell: (params) => (
                <div>
                    {(params?.value)}
                </div>
            )
        },
        {field: 'amount', headerName: "Amount", flex: 1,
            renderCell: (params) => (
                <div>
                    {formatMoney(params?.value)}
                </div>
            )
        },
        {field: 'status', headerName: "Status",
            renderCell: (params) => (
                <StatusCol params={params} />
            )
        }

    ]

    async function handleAccept(ev) {
        ev?.preventDefault();

        const payload = {
            requestPayoutId: openAccept?._id
        }
        setLoadings({...loadings,accept: true})
        const res = await acceptPayoutRequest(payload);
        setLoadings({...loadings,accept: false})
        if(res?.return) {
            const reqOTP = await isPayoutOTPNeeded(payload);
            if(reqOTP?.return)
                if(reqOTP?.data?.isOTPNeeded)
                    return setOpenOTPModal(payload)
            enqueueSnackbar(res.msg,{variant: 'success'})
            setOpenAccept(false)
            load();
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }
    async function handlePayoutOTP(ev) {
        ev?.preventDefault();

        const payload = {
            requestPayoutId: openOTPModal?._id,
            otp: openOTPModal?.otp,
        }
        setLoadings({...loadings,otp: true})
        const res = await finalizePayout(payload);
        setLoadings({...loadings,otp: false})
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'})
            setOpenOTPModal(false)
            load();
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }
    async function handleConfirmManually(ev) {
        ev?.preventDefault();

        const payload = {
            requestPayoutId: openConfirm?._id
        }
        setLoadings({...loadings,confirmManual: true})
        const res = await confirmManualPayoutRequest(payload);
        setLoadings({...loadings,confirmManual: false})
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'})
            setOpenConfirm(false)
            load();
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }
    async function handleReject(ev) {
        ev?.preventDefault();

        const payload = {
            requestPayoutId: openReject?._id,
            reason: openReject?.reason,
        }
        setLoadings({...loadings,reject: true})
        const res = await rejectPayoutRequest(payload);
        setLoadings({...loadings,reject: false})
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'})
            setOpenReject(false)
            load();
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }
    async function handleResendOTP() {
        setLoadings({...loadings,resendOTP:true})
        const res = await resendPayoutOTP(openOTPModal?._id)
        setLoadings({...loadings,resendOTP:false})
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'})
        } else enqueueSnackbar(res.msg,{variant: 'error'})
        
    }
    
  return (
    <div>
        <ActionsContext.Provider value={{
            accept: setOpenAccept,
            reject: setOpenReject,
            view: setView,
            confirmManually: setOpenConfirm,
            setOpenOTPModal,
        }}>
            <CustomTable loading={loadings?.load} columns={columns} rows={data} 
                searchProps={{
                    searchable: true,
                    search: setSearchValue,
                }}   
                rowCount={paginationModel?.rowCount}
                paginationMode="server"
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}

            />
        </ActionsContext.Provider>

    </div>
  )
}


function StatusCol({params}) {        
    function getStatus(stat) {
        if(stat?.toLowerCase()?.includes('waiting'))
            return 'Pending';
        return stat;
    }
        
    const status = getStatus(params?.row?.status);
    
    return (
        <div className='flex gap-2 items-center w-full justify-between'>
            <span className={`${alertType[status?.toLowerCase()]}`}>{status}</span>
        </div>
    )
}